module.exports = __webpack_public_path__ + "img/3.fb7ec043.png";